import axios from 'axios';

// URL de l'API : surchargeable via REACT_APP_API_URL (.env.local pour pointer
// sur un backend lancé en local), sinon backend de production.
const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'https://madrasati-98948488e6a3.herokuapp.com/api'
});

instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

// École suspendue par le super admin pendant la session : on déconnecte et on
// renvoie vers la page de connexion, qui affiche le motif.
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403 && error.response.data?.code === 'SCHOOL_SUSPENDED') {
      const teacher = window.location.pathname.startsWith('/teacher');
      localStorage.removeItem(teacher ? 'teacherToken' : 'token');
      const target = teacher ? '/teacher-login' : '/login';
      if (window.location.pathname !== target) window.location.assign(`${target}?suspended=1`);
    }
    return Promise.reject(error);
  }
);

export default instance;